import { createFileRoute } from "@tanstack/react-router";
import { SequencePage } from "@/features/outreach/SequencePage";

export const Route = createFileRoute("/_app/outreach/$sequence")({ component: Page });

function Page() {
  const { sequence } = Route.useParams();
  return <SequencePage id={sequence} />;
}
